import script from "./indexPage.vue?vue&type=script&setup=true&lang=js"
export * from "./indexPage.vue?vue&type=script&setup=true&lang=js"

import "./indexPage.vue?vue&type=style&index=0&id=615f0a13&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-615f0a13"]])

export default __exports__